<header class="top-navigation" role="banner" aria-label="Top navigation">
    <nav class="top-navigation__desktop-links" aria-label="Primær navigation">
        <ul class="top-navigation__list" role="list">
            @for (item of menuItems; track item) {
            <li class="top-navigation__item" role="listitem">
                <a class="top-navigation__link" [routerLink]="item.route" routerLinkActive="top-navigation__link--active" [ariaCurrentWhenActive]="'page'">
                    <mat-icon class="top-navigation__icon" [svgIcon]="item.icon" aria-hidden="true"></mat-icon>
                    <span class="top-navigation__label">{{ item.label }}</span>
                </a>
            </li>
            }
        </ul>
    </nav>
    <nav class="top-navigation__menu" aria-label="Brugermenu">
        <div class="top-navigation__content">
            <span class="top-navigation__user" aria-hidden="true">{{ userInfoData?.works?.name }}</span>
        </div>
        <button
            #burgerButton
            (click)="toggleMenu(); $event.stopPropagation()"
            class="top-navigation__burger"
            [attr.aria-expanded]="showMenu"
            [attr.aria-label]="showMenu ? 'Luk brugermenu' : 'Åbn brugermenu'"
            aria-controls="user-dropdown-menu"
            aria-haspopup="menu"
            type="button"
        >
            <mat-icon class="top-navigation__icon" svgIcon="account-outline" aria-hidden="true"></mat-icon>
        </button>

        @if(showMenu) {
        <menu id="user-dropdown-menu" class="dark-panel" role="menu" aria-label="Brugerhandlinger" (closeMenu)="closeAndFocus()">
            <button (click)="openInfo()" role="menuitem" type="button" aria-label="Åbn brugeroplysninger">
                <mat-icon class="top-navigation__icon" svgIcon="info-outline" aria-hidden="true"></mat-icon>
                <span>Info</span>
            </button>
            <button (click)="toggleTheme()" role="menuitem" type="button" [attr.aria-label]="isDark() ? 'Skift til lyst tema' : 'Skift til mørkt tema'">
                <mat-icon class="top-navigation__icon mat-ligature-font" aria-hidden="true">{{ isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
                <span>{{ isDark() ? 'Lyst tema' : 'Mørkt tema' }}</span>
            </button>
            <a href="#/logout" role="menuitem" aria-label="Log ud af applikationen">
                <mat-icon class="top-navigation__icon" svgIcon="menu-logout" aria-hidden="true"></mat-icon>
                <span>Log ud</span>
            </a>
        </menu>
        }
    </nav>
</header>

@if(showInfo) {
<user-info [data]="userInfoData" (close)="closeInfo()" />
}
